import { useEffect } from 'react';
import type { OrganisationServiceRoot } from 'src/apis/organisation-service/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import { handleErrorWithNotification } from 'src/utils/handle-error';

export function useOrganisationService() {
  const organisationService = useAxios(
    (axios, baseConfig) =>
      axios.request<OrganisationServiceRoot>({
        ...baseConfig,
        url: PRISMA_CONFIG.organisationService,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'organisation-service-root',
    }
  );

  useEffect(() => {
    organisationService.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return organisationService;
}

export type OrganisationServiceRequest = ReturnType<
  typeof useOrganisationService
>;

export function useOptionalOrganisationServiceManual() {
  const organisationService = useAxios(
    (axios, baseConfig) =>
      axios.request<OrganisationServiceRoot>({
        ...baseConfig,
        url: PRISMA_CONFIG.organisationService,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'organisation-service-root',
      onError(error) {
        if (!isServerError(error, 401)) {
          handleErrorWithNotification({
            error,
            setReauthenticate: () => {},
          });
        }
        return error;
      },
    }
  );

  return organisationService;
}

export type OptionalOrganisationServiceManualRequest = ReturnType<
  typeof useOptionalOrganisationServiceManual
>;

export function useOptionalOrganisationService() {
  const organisationService = useOptionalOrganisationServiceManual();

  useEffect(() => {
    organisationService.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return organisationService;
}

export type OptionalOrganisationServiceRequest = ReturnType<
  typeof useOptionalOrganisationService
>;
